import { Target } from '../ui/shared/enums/Target';
import { FontWeight } from '../ui/shared/enums/FontWeight';
import { UnderLineType } from '../ui/shared/enums/UnderLineType';
import { Context } from '../ui/shared/enums/Context';
import { VisualStyle } from '../ui/shared/enums/VisualStyle';
/**
 * Default configurations for link types
 */
export const defaultInternalLink = {
    link: '',
    text: undefined,
    target: Target.Self,
    fontWeight: FontWeight.Normal, // Using FontWeight enum
    hoverColor: '',
    isUnderLine: UnderLineType.Underline, // Using UnderLineType enum
    linkColor: Context.None, // Using Context enum
    visualStyle: VisualStyle.Default, // Add visualStyle property
};
/**
 * Placeholder configurations for link types, for use in testing or development
 */
export const placeholderInternalLink = {
    link: 'https://domain/some-link',
    text: 'Some Descriptive Text For The Link',
    target: Target.Self,
    fontWeight: FontWeight.Normal, // Using FontWeight enum
    hoverColor: '',
    isUnderLine: UnderLineType.Underline, // Using UnderLineType enum
    linkColor: Context.None, // Using Context enum
    visualStyle: VisualStyle.Highlighted, // Add visualStyle property
};
//# sourceMappingURL=InternalLinkDefaults.js.map